import React, { useEffect, useRef, useState } from "react";
import Status from "./status";
import { getAllParameters } from "../../helper/api";
import { isAuthenticated } from "../../../auth";


const PlannerFilter = (props) => {

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);

  const {user, token} = isAuthenticated();
  const [currentElementId, setCurrentElementId] = useState("");
  const [selectedAccessRight, setSelectedAccessRight] = useState("All");
  const [selectedPlannerType, setSelectedPlannerType] = useState("workout");
  const [selectedContentRole, setSelectedContentRole] = useState("All");
  const [weekFrequency, setWeekFrequency] = useState("");
  const [exerciseLevel, setExerciseLevel] = useState([]);
  const [tempIDs, setTempIDs] = useState([]);
  const [selectedExerciseLevel, setSelectedExerciseLevel] = useState("");
  const [plannerFilter, setPlannerFilter] = useState({
    getAccessRight: "All",
    // getPlannerType: "workout",
    getPlannerRole: "All",
    getWeekFrequency: "",
    getExerciseLevels: [],
    getStatus: true
  });
  const [status, setStatus] = useState(true);
  
  const selectDropdownType = (type, value) => {
    if(type == "access-right"){
      setSelectedAccessRight(value);
      setPlannerFilter(oldData => ({
        ...oldData,
        getAccessRight: value
      }));
    }

    // if(type == "planner-type"){
    //   setSelectedPlannerType(value);
    //   setPlannerFilter(oldData => ({
    //     ...oldData,
    //     getPlannerType: value
    //   }));
    // }

    if(type == "planner-role"){
      setSelectedContentRole(value)
      setPlannerFilter(oldData => ({
        ...oldData,
        getPlannerRole: value
      }));
    }

    props.plannerFilterStatus(plannerFilter);

  }

  const toggleInputFields = (id) => {
    if (currentElementId == id) {
      setCurrentElementId('')
    } else {
      setCurrentElementId(id);
      if(id == "week-frequency"){
        inputRef1.current.focus();
      }
      if(id == "completed-sessions"){
        inputRef2.current.focus();
      }
    }
  };


  const handleChange = (name) => event => {
    // value = !value ? event.target.value : value;
    if(name == "week-frequency"){
      setWeekFrequency(event.target.value);
      setPlannerFilter(oldData => ({
        ...oldData,
        getWeekFrequency: event.target.value,
      }));
      props.plannerFilterStatus(plannerFilter);
    }
  }

  const handleTempIDs = (id, type) => event => {
    let ids = [...tempIDs];
    let index = ids.findIndex(d => d == id);

    if (index == -1) {
      ids.push(id);
    } else {
      ids.splice(index, 1);
    }
    setTempIDs(ids);

    // setExerciseLevel((prev) => {
    //   const updated = { ...prev };

    //   Object.keys(updated).forEach((key) => {
    //     updated = updated[key].filter((item) => item !== id);
    //   });

    //   const currentList = [...(prev[type] || [])];

    //   if (!prev[type].includes(id)) {
    //     updated[type].push(id);
    //   }

    //   props.setParameterFilter(updated);

    //   return updated;
    // });
  }

  const GetAllParameters = async () => {
    try {
      let params = {
        noLimit: 'noLimit',
        sortByInstafit: 'sort',
        type: "exerciseLevel"
      }
      let response = await getAllParameters(user._id, token, params);
      setExerciseLevel(response);
    } catch (error) {

    }
  }

  const getStatus = (value) => {
    setPlannerFilter(oldData => ({
      ...oldData,
      getStatus: value
    }))
  }

  // useEffect(() => {
  //   setPlannerFilter(oldData => ({
  //     ...oldData,
  //     getAccessRight: selectedAccessRight,
  //     getContentRole: selectedContentRole,
  //     getWeekFrequency: weekFrequency,
  //     getExerciseLevels: exerciseLevel,
  //     getStatus: status
  //   }));
  // },[selectedAccessRight, selectedContentRole, weekFrequency, exerciseLevel]);

  useEffect(() => {
    setPlannerFilter(oldData => ({
      ...oldData,
      getExerciseLevels: tempIDs
    }));
    props.plannerFilterStatus(plannerFilter);
  },[tempIDs])

  useEffect(() => {
    props.plannerFilterStatus(plannerFilter)
  },[plannerFilter])

  useEffect(() => {
    GetAllParameters();
  },[]);

  useEffect(() => {
  if (props.isReset) {
    setCurrentElementId("");
    setSelectedAccessRight("All");
    setSelectedContentRole("All");
    setWeekFrequency("");
    setTempIDs([]);
    setPlannerFilter({
      getAccessRight: "All",
      getPlannerRole: "All",
      getWeekFrequency: "",
      getExerciseLevels: [],
      getStatus: true
    });
    if (props.handleResetState) props.handleResetState();
  }
}, [props.isReset]);

  return(
    <div className="w-full h-full">
      <Status getStatus={getStatus} isReset={props.isReset} handleResetState={props.handleResetState} />
       <div className="d-flex space-between m-t-16">
        <div onClick={()=>toggleInputFields("access-right")} className={`${currentElementId == "access-right" || selectedAccessRight ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "access-right" || selectedAccessRight) ? "1px solid var(--darkBlue)" : "", width:"49%" }}>
          <div className="flex-item d-flex" style={{marginTop: (currentElementId == "access-right" || selectedAccessRight) ? "4px" : ""}}>
            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "access-right" || selectedAccessRight) ? "12px" : "16px", lineHeight: (currentElementId == "access-right" || selectedAccessRight) ? "12px" : "14px", color: (currentElementId == "access-right" || selectedAccessRight) ? "var(--darkBlue)" : "", transition: "180ms" }}>Access Right</p>
          </div>
          <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
            <svg className="flex-item" style={{ transform: currentElementId == "access-right" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
            </svg>
          </div>
          <input id="access-right" className={`${(currentElementId == "access-right" || selectedAccessRight) ? "active-input-field" : "inactive-input-field"} m-t-5 fs-16`} type="text" placeholder="Select Access Right" value={selectedAccessRight ? selectedAccessRight : ""} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
          {
            currentElementId == "access-right" && (
              <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5"}}>
                <div className="w-full" >
                  <div onClick={()=>selectDropdownType("access-right", "all")} className="global-input-field-arrow-dropdown-item">
                    <p className="flex-item">All</p>
                  </div>
                </div>
                <div className="w-full">
                  <div onClick={()=>selectDropdownType("access-right", "private")} className="global-input-field-arrow-dropdown-item">
                    <p className="flex-item">Private</p>
                  </div>
                </div>
                <div className="w-full">
                  <div onClick={()=>selectDropdownType("access-right", "public")} className="global-input-field-arrow-dropdown-item">
                    <p className="flex-item">Public</p>
                  </div>
                </div>
              </div>
            )
          }
        </div>
        <div onClick={()=>toggleInputFields("planner-role")} className={`${currentElementId == "planner-role" || selectedContentRole ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "planner-role" || selectedContentRole) ? "1px solid var(--darkBlue)" : "", width:"49%" }}>
          <div className="flex-item d-flex" style={{marginTop: (currentElementId == "planner-role" || selectedContentRole) ? "4px" : ""}}>
            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "planner-role" || selectedContentRole) ? "12px" : "16px", lineHeight: (currentElementId == "planner-role" || selectedContentRole) ? "12px" : "14px", color: (currentElementId == "planner-role" || selectedContentRole) ? "var(--darkBlue)" : "", transition: "180ms" }}>Access Types</p>
          </div>
          <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
            <svg className="flex-item" style={{ transform: currentElementId == "planner-role" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
            </svg>
          </div>
          <input id="planner-role" className={`${(currentElementId == "planner-role" || selectedContentRole) ? "active-input-field" : "inactive-input-field"} m-t-5 fs-16`} type="text" placeholder="Select Access Right" value={selectedContentRole ? selectedContentRole : ""} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
          {
            currentElementId == "planner-role" && (
              <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5"}}>
                <div className="w-full" >
                  <div onClick={()=>selectDropdownType("planner-role", "All")} className="global-input-field-arrow-dropdown-item">
                    <p className="flex-item">All</p>
                  </div>
                </div>
                <div className="w-full">
                  <div onClick={()=>selectDropdownType("planner-role", "Branch Planner")} className="global-input-field-arrow-dropdown-item">
                    <p className="flex-item">Branch Planner</p>
                  </div>
                </div>
                <div className="w-full">
                  <div onClick={()=>selectDropdownType("planner-role", "Workout Plus Planner")} className="global-input-field-arrow-dropdown-item">
                    <p className="flex-item">WorkoutPlus Planner</p>
                  </div>
                </div>
                <div className="w-full">
                  <div onClick={()=>selectDropdownType("planner-role", "My Planner")} className="global-input-field-arrow-dropdown-item">
                    <p className="flex-item">My Planner</p>
                  </div>
                </div>
              </div>
            )
          }
        </div>
      </div>
      <div className="d-flex space-between">
        {/* <div onClick={()=>toggleInputFields("planner-type")} className={`${currentElementId == "planner-type" || selectedPlannerType ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "planner-type" || selectedPlannerType) ? "1px solid var(--darkBlue)" : "", width:"49%" }}>
          <div className="flex-item d-flex" style={{marginTop: (currentElementId == "planner-type" || selectedPlannerType) ? "4px" : ""}}>
            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "planner-type" || selectedPlannerType) ? "12px" : "16px", lineHeight: (currentElementId == "planner-type" || selectedPlannerType) ? "12px" : "14px", color: (currentElementId == "planner-type" || selectedPlannerType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Planner Type</p>
          </div>
          <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
            <svg className="flex-item" style={{ transform: currentElementId == "planner-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
            </svg>
          </div>
          <input id="planner-type" className={`${(currentElementId == "planner-type" || selectedPlannerType) ? "active-input-field" : "inactive-input-field"} m-t-5 fs-16`} type="text" placeholder="Select Access Right" value={selectedPlannerType ? selectedPlannerType : ""} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
          {
            currentElementId == "planner-type" && (
              <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5"}}>
                <div className="w-full">
                  <div onClick={()=>selectDropdownType("planner-type", "day")} className="global-input-field-arrow-dropdown-item">
                    <p className="flex-item">Day</p>
                  </div>
                </div>
                <div className="w-full" >
                  <div onClick={()=>selectDropdownType("planner-type", "workout")} className="global-input-field-arrow-dropdown-item">
                    <p className="flex-item">Workout</p>
                  </div>
                </div>
                <div className="w-full">
                  <div onClick={()=>selectDropdownType("planner-type", "fitness")} className="global-input-field-arrow-dropdown-item">
                    <p className="flex-item">Fitness</p>
                  </div>
                </div>
                <div className="w-full">
                  <div onClick={()=>selectDropdownType("planner-type", "nutrition")} className="global-input-field-arrow-dropdown-item">
                    <p className="flex-item">Nutrition</p>
                  </div>
                </div>
              </div>
            )
          }
        </div> */}
        <div onClick={()=>toggleInputFields("week-frequency")} className={`${currentElementId == "week-frequency" || weekFrequency ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "week-frequency" || weekFrequency) ? "1px solid var(--darkBlue)" : "", width:"49%"}}>
          <div className="flex-item d-flex" style={{marginTop: (currentElementId == "week-frequency" || weekFrequency) ? "4px" : ""}}>
            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "week-frequency" || weekFrequency) ? "12px" : "16px", lineHeight: (currentElementId == "week-frequency" || weekFrequency) ? "12px" : "14px", color: (currentElementId == "week-frequency" || weekFrequency) ? "var(--darkBlue)" : "", transition: "180ms" }}>Week Frequency</p>
          </div>
          <input ref={inputRef1} onChange={handleChange("week-frequency")} className={`${(currentElementId == "week-frequency" || weekFrequency) ? "active-input-field" : "inactive-input-field"} m-t-4 fs-16`} type="number" placeholder="Enter value" value={weekFrequency ? weekFrequency : ""} />
        </div>
      </div>
      <div className="chips-filter-container m-b-12">
        <div className="d-flex m-b-8">
          <p className="flex-item fs-16 font-weight-700 color-dark-blue m-t-6 p-l-4">Exercise Levels</p>
        </div>
        <div className="chips-scroll-container d-flex-wrap">
          {
            exerciseLevel.map(data => {
              return(
                <div onClick={handleTempIDs(data._id, data)} className="d-flex chips-filter-item m-r-12 m-b-12" style={{backgroundColor: tempIDs.findIndex(id => id == data._id) != -1 && "#E33A34"}}>
                  <p className="flex-item fs-12" style={{color: tempIDs.findIndex(id => id == data._id) != -1 && "#ffffff"}}>{data.name}</p>
                </div>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}

export default PlannerFilter;